export enum MailingList {
  CANADA = "CANADA",
  EU = "EU",
  US = "US",
}

export type MailingListState = {
  isCreatingSubscription: boolean;
};
